import client from '../httpClient';

const librarydirCopyApi = (params) => {
  return client.post('/library-directories/copy/', JSON.stringify(params), { isShowLoading: false });
};

export default librarydirCopyApi;
